import { FileController } from "services/file/FileController";
import { useToast } from "../useToast";

const { upload } = FileController();

export const uploadFile = async (file) => {
  if (!file) return undefined;
  let formData = new FormData();
  formData.append("file", file);
  formData.append("Content-Type", file.type);
  return await upload(formData)
    .then((file) => file.filename)
    .catch(() => {
      throw new Error(
        `There is a problem with uploading file "${file.name}", please try again.`
      );
    });
};

const processFileFields = async (body) => {
  if (typeof body === "object" && body) {
    if (body instanceof FileList) {
      if (body.length > 1) body = [...body].map((filename) => ({ filename }));
      else if (body.length === 1) {
        body = await uploadFile(body[0]);
        return body;
      } else return null;
    }
    for (let key of Object.keys(body)) {
      if (body[key] instanceof File && body[key].size > 0) {
        body[key] = await uploadFile(body[key]);
      } else body[key] = await processFileFields(body[key]);
    }
  }
  return body;
};

export const useFileUpload = () => {
  const { showToast } = useToast();

  const handleFileFields = async (requestBody) => {
    return processFileFields(requestBody)
      .then((values) => values)
      .catch((e) => {
        let msg = "There is a problem uploading files";
        if (typeof e === "string") msg = e;
        showToast(msg, "error");
      });
  };

  return { handleFileFields };
};
